import React, { useMemo, useState } from 'react'
import '../style/popup.css'

const safeParse = (value, fallback) => {
  if (value == null) return fallback;
  try { return JSON.parse(value) ?? fallback; } catch { return fallback; }
};

const AddClassesPopup = ({setShowAddClassesPopup, setSavedClasses, savedClasses, getData, showNotification}) => {
    const [searchTxt, setSearchTxt] = useState('');
    const [addClasses, setAddClasses] = useState(savedClasses);
    const [loading, setLoading] = useState(false);
    const [showAddedClasses, setShowAddedClasses] = useState(false);
    const allClasses = safeParse(localStorage.getItem('allClasses'), []);
    const withoutDays = useMemo(() => {
        const seen = new Set();
        const flat = [];
        allClasses.forEach(day => {
            (day.classes || []).forEach(cl => {
                if (!seen.has(cl.val)) {
                    seen.add(cl.val);
                    const cleanCl = String(cl.val).toLowerCase().replace(/[^a-z0-9]/g, '');
                    flat.push({
                        ...cl,
                        checked: addClasses.some(each => 
                            String(each.val).toLowerCase().replace(/[^a-z0-9]/g, '') === cleanCl
                        )
                    });
                }
            });
        });
        return flat;
    }, [allClasses, addClasses]);
    let [classes, setClasses] = useState(withoutDays);
    const searchData = (searching)=>{
        setLoading(true)
        let newClasses = [];
        withoutDays.forEach(each => {
            if(each.val.toLowerCase().includes(searching.toLowerCase())){
                newClasses.push(each);
            }
        });
        setClasses(newClasses);
        setLoading(false);
    }
    const handleKeyPress = (e) => {
        if(e.key==='Enter')
            searchData(searchTxt.trim());
    }
  return (
    <div className="container">
        <div className="popup">
            <div className="popup-header">
            <h2>Add Classes</h2>
            <button className="close" onClick={()=>{setShowAddClassesPopup(false)}}>&times;</button>
            </div>
            <div className="search-box sb-pp">
                <i className="fa fa-magnifying-glass"></i>
                <input type="text" placeholder="e.g. bcs-3a, basit ali, coal" className='add-search-input' value={searchTxt} onKeyDown={handleKeyPress} onChange={(e)=>{setSearchTxt(e.target.value);searchData(e.target.value)}}/>
                <button className='search-button' onClick={()=>{searchData(searchTxt.trim())}} >Search</button>
            </div>
            
            <button 
                className={`added-classes-toggle ${addClasses.length > 0 ? 'has-items' : ''}`}
                onClick={() => setShowAddedClasses(!showAddedClasses)}
            >
                <i className={`fa ${showAddedClasses ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                <span>My Classes</span>
                {addClasses.length > 0 && <span className="added-count-badge">{addClasses.length}</span>}
            </button>
            
            {showAddedClasses && (
                <div className="added-classes-section">
                    {addClasses.length > 0 ? (
                        <div className="added-classes-list">
                            {addClasses.map((item, index) => (
                                <div key={item.val || index} className="added-class-tag">
                                    <span>{item.val}</span>
                                    <button 
                                        className="remove-class-btn"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            const newAddClasses = addClasses.filter((_, i) => i !== index);
                                            setAddClasses(newAddClasses);
                                            const newClasses = classes.map(c => 
                                                c.val === item.val ? { ...c, checked: false } : c
                                            );
                                            setClasses(newClasses);
                                        }}
                                        title="Remove class"
                                    >
                                        <i className="fa fa-times"></i>
                                    </button>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="no-classes-message">
                            <i className="fa fa-info-circle"></i>
                            <span>No classes added yet. Select classes from the list below.</span>
                        </div>
                    )}
                </div>
            )}
            
            <div className="popup-content">
            {loading && <div className="loader"></div>}
                {classes.map((each, ind)=>{
                    const checkboxId = `class-check-${each.val || ind}`;
                    return <label key={each.val || ind} className='each-class' htmlFor={checkboxId}>
                        <input type="checkbox" id={checkboxId} name={each.key} checked={each.checked || false} onChange={(e) => {
                            const isChecked = e.target.checked;
                            let newClasses = [...classes];
                            let newaddClasses = [...addClasses];
                            if(isChecked){
                                newaddClasses.push(each);
                                setAddClasses(newaddClasses);
                            }
                            else{
                                newaddClasses = newaddClasses.filter((item)=>item.val!==newClasses[ind].val);
                                setAddClasses(newaddClasses);
                            }
                            newClasses[ind].checked = isChecked;
                            setClasses(newClasses);
                        }}/>
                        <span className="each-class-label">{each.val}</span>
                    </label>
                })}
            </div>
            <div className="popup-footer">
                <button className="add" onClick={()=>{setSavedClasses(addClasses); localStorage.setItem('savedClasses', JSON.stringify(addClasses)); setShowAddClassesPopup(false); getData('', true); showNotification('classes added successfully', null)}}>Add</button>
                </div>
        </div>
    </div>
  )
}

export default AddClassesPopup